module.exports = {
    footerText: 'Copyright Keepsporting © ',
}
